import { fetchJSON } from '@bonnet/core/fetch';
import _get from 'lodash/get';
import { logger } from '@bonnet/core/logger';
import cache from '../cache';
import constants from '../constants';
import getReferenceApiPath from './getReferenceApiPath';
const {
  MARKETS
} = constants;
const circuitBreaker = {
  id: 'market',
  timeout: 20000,
  fallback: {
    success: false,
    payload: {}
  }
};
export default async function getMarket(zip) {
  let response;
  try {
    // validate zip exists or is 5 digits
    if (!zip || zip === '' || zip && !/^\d{5}$/.test(zip)) {
      throw Error(`${zip} argument is missing or invalid`);
    }
    let success = false;
    let payload;

    // retrieve zipcodes from cache or get them from the remote API
    const markets = await cache.get(MARKETS);

    // lookup market data in markets table by zip code
    const market = _get(markets, zip);

    // return cached market data if we have it
    if (market) {
      success = true;
      payload = market;
    } else {
      // If market is not available from memory cache then we need to fetch it from the API
      const marketResponse = await fetchJSON(getReferenceApiPath(MARKETS), {
        circuitBreaker,
        query: {
          zip
        }
      });
      if (marketResponse.success) {
        ({
          success,
          payload
        } = marketResponse);

        // update the market cache with this zipcode's market data
        cache.put(MARKETS, {
          ...markets,
          [zip]: payload
        });
      }
    }

    // throw error if the fetch returns unsuccessfulky
    if (!success) {
      throw Error(`cannot find zipcode data for ${zip}`);
    }

    // set the payload and success status on the response
    response = {
      success,
      payload
    };
  } catch (error) {
    const {
      message
    } = error;
    if (process.env.NODE_ENV === 'development') {
      logger.log(`[@atc/bonnet-reference/getMarket] ${message}`);
    }
    response = {
      success: false,
      message,
      error
    };
  }
  return response;
}